/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/**
 * Iframe entry point - Reads parameters from the url and initializes the widget
 */
(function () {
    const supportedWidgetTypes = [
        "spaces_overview",
        "space_details",
        "open_challenge",
    ];
    const urlParams = new URLSearchParams(window.location.search);

    const params = Object.fromEntries(
        [
            ["apiKey", ""],
            ["widgetType", ""],
            ["organisationId", ""],
            ["useSelfUrl", ""],
            ["primaryColor", ""],
            ["secondaryColor", ""],
            ["buttonBorderRadius", ""],
            ["filterLabelColor", ""],
            ["challengeSpaceDetailPage", ""],
            ["challengeSpaceId", ""],
            ["challengeSpaceOverviewPage", ""],
            ["hideChallengeSpaceOverviewFilters", "false"],
            ["showOrganisationsFilter", "false"],
            ["showSearchField", "false"],
            ["organisationSlugSource", ""],
            ["organisationBaseUrl", ""],
            ["columnCount", "3"],
            ...urlParams.entries(),
        ].map(([key, value]) => [
            key,
            typeof value === "string" ? value.trim() : value,
        ])
    );

    const {
        apiKey,
        widgetType,
        organisationId,
        useSelfUrl,
        primaryColor,
        secondaryColor,
        buttonBorderRadius,
        filterLabelColor,
        challengeSpaceDetailPage,
        challengeSpaceId,
        challengeSpaceOverviewPage,
        hideChallengeSpaceOverviewFilters,
        showOrganisationsFilter,
        showSearchField,
        organisationSlugSource,
        organisationBaseUrl,
        columnCount,
    } = params;

    const styles = {
        ...(primaryColor ? { primaryColor } : {}),
        ...(secondaryColor ? { secondaryColor } : {}),
        ...(buttonBorderRadius ? { buttonBorderRadius } : {}),
        ...(filterLabelColor ? { filterLabelColor } : {}),
    };
    if (
        !widgetType ||
        (widgetType && !supportedWidgetTypes.includes(widgetType))
    ) {
        document.getElementById(
            "mc-embed-widget"
        ).innerHTML = `<div style='color: red; font-weight: bold;'>Widget type ${widgetType} is not supported. Supported types are: ${supportedWidgetTypes.join(
            ", "
        )}</div>`;
        return;
    }

    if (!apiKey) {
        document.getElementById("mc-embed-widget").innerHTML =
            "<div style='color: red; font-weight: bold;'>Please provide an api key in the url parameters</div>";
        return;
    }

    const MCEmbedWidgetInstance = window.MCEmbedWidgetsSDK;

    MCEmbedWidgetInstance.init({
        containerId: "mc-embed-widget",
        apiBasePath: `${process.env.API_HOST}/api`,
        widgetOptions: {
            type: widgetType,
            apiKey: apiKey,
            organisationId: organisationId,
            columnCount: columnCount,
            useSelfUrl: useSelfUrl === "true",
            hideChallengeSpaceOverviewFilters:
                hideChallengeSpaceOverviewFilters === "true",
            showOrganisationsFilter: showOrganisationsFilter === "true",
            showSearchField: showSearchField === "true",
            challengeSpaceOverviewPage: challengeSpaceOverviewPage,
            challengeSpaceDetailPage: challengeSpaceDetailPage,
            ...(organisationSlugSource ? { organisationSlugSource } : {}),
            ...(organisationBaseUrl ? { organisationBaseUrl } : {}),
            styles: styles,
            ...(challengeSpaceId ? { challengeSpaceId } : {}),
        },
        organisationId: organisationId,
        apiKey: apiKey,
    });
})();
